


















import URLHelper from '@/helpers/URLHelper';
import Vue from 'vue';
import config from '../../../config';
import ProductsOverviewHeadline from './ProductsOverviewHeadline.vue';
import ProductSlider from '../common/productslider/ProductSlider.vue';
import { IProduct } from '../../common/interfaces/products.interface';

interface IProductsOverviewHeadComponent {
  products: IProduct[];
  showOffers: boolean;
}

export default Vue.extend({
  name: `ProductsOverviewHead`,
  components: { ProductSlider, ProductsOverviewHeadline },
  data(): IProductsOverviewHeadComponent {
    return {
      products: [],
      showOffers: false,
    };
  },
  async mounted(): Promise<void> {
    const { slug } = URLHelper.parsedUrlObject;
    if(config.products.specialShopCategoriesURLSlugs.offers.includes(slug)) {
      this.showOffers = true;
    }
    this.products = await this.$productService.getHomepageOfferProducts();
  },
});
